<template >
  <div class="frame">
    <div class="title">
      <div class="left_area">
        {{ title }}
      </div>
      <div class="right_area" v-if="routerTo">
        <router-link class="top_more" :to="routerTo">
          <a-icon type="right" />
        </router-link>
      </div>
    </div>
    <div class="frame_content">
      <slot name="contentSlot" />
    </div>
  </div>
</template>

<script >
import { RightCircleOutlined, HomeOutlined } from "@ant-design/icons-vue";

export default {
  name: "frame",
  props: {
    title: {
      type: String,
      default: "标题",
    },
    routerTo: {
      type: String,
      default: "",
    },
    color: {
      type: String,
      default: "",
    },
  },
  components: {
    RightCircleOutlined,
    HomeOutlined,
  },
};
</script>

<style lang="scss" scoped>
$base_width: 375;
@function pxRem($px) {
  @return ($px / $base_width) * 10 + rem;
}
.frame {
  position: relative;
  background-color: #fff;
  height: 100%;
  box-sizing: border-box;
  border-width: 1px;
  border-style: solid;
  border-color: rgba(242, 242, 242, 1);
  .title {
    display: flex;
    height: pxRem(50);
    justify-content: space-between;
    align-items: center;
    padding: pxRem(10) pxRem(20);
    position: relative;
    // border-bottom: 1px solid rgba(233, 233, 233, 1);
    .left_area {
      position: relative;
      font-weight: 700;
      font-size: pxRem(13);
      color: #333;
      display: flex;
      align-items: center;
      .left_icon {
        padding-right: pxRem(5);
        font-weight: 400;
        font-size: pxRem(14);
        
        // color: #409eff;
      }
    }
    &::before {
      position: absolute;
      content: "";
      width: pxRem(5);
      height: pxRem(15);
      background: linear-gradient(#7EA2F1, #4D80F1);
      border-radius: pxRem(8);
      top: 50%;
      left: pxRem(10);
      -webkit-transform: translateY(-50%);
      transform: translateY(-50%);
    }

    .right_area {
      // padding-right: 20px;

      .top_more {
        display: flex;
        align-items: center;
        color: #CCCCCC;
      }
    }
  }
  .frame_content {
  }
}
</style>